import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Wave from 'react-wavify';
import useSection from '../../hooks/use-sections';
import ScrollUp from '../Home/ScrollUp';
import Sections from './Sections';
import StyledGameApi from './styles';

import Footer from '../../containers/Footer';
import TopNavigation from '../../containers/TopNavigation';

const GameApi = () => {
    const { sectionWhitelabel } = useSection();
    const { i18n } = useTranslation();
    const [isTop, setIsTop] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleScroll = () => {
                const position = window.scrollY;
                if (position === 0) {
                    setIsTop(false);
                } else if (position >= 470) {
                    setIsTop(true);
                }
            };

            window.addEventListener('scroll', handleScroll);

            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, [isTop]);

    return (
        <Box className={i18n.language === 'en-US' ? 'en' : 'kr'} sx={{ position: 'relative' }}>
            <TopNavigation />
            <Box
                sx={{
                    minHeight: 'calc(100vh - 80px)',
                    height: '100%',
                    width: '100%',
                    overflowX: 'visible',
                    padding: '0 !important',
                    marginTop: '80px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        height: '560px',
                        width: '100%',
                        position: 'fixed',
                        zIndex: -1,
                        // background: isTop ? '#02b201' : '#acfa4f',
                        background: isTop ? '#eef7e8' : '#baf98a',
                    }}
                ></Box>
                <Wave
                    // fill={isTop ? '#acfa4f' : '#02b201'}
                    fill={isTop ? '#baf98a' : '#eef7e8'}
                    paused={false}
                    style={{
                        display: 'flex',
                        height: '50px',
                        position: 'fixed',
                        zIndex: -1,
                        marginTop: '530px',
                    }}
                    options={{
                        height: 20,
                        amplitude: 20,
                        speed: 0.15,
                        points: 3,
                    }}
                />
                <Wave
                    // fill={isTop ? '#acfa4f' : '#02b201'}
                    fill={isTop ? '#baf98a' : '#eef7e8'}
                    paused={false}
                    style={{
                        display: 'flex',
                        marginTop: '-5px',
                        height: '50px',
                        transform: 'scaleY(-1)',
                        position: 'fixed',
                        zIndex: -1,
                        marginTop: '558px',
                    }}
                    options={{
                        height: 10,
                        amplitude: 20,
                        speed: 0.25,
                        points: 3,
                    }}
                />
                <StyledGameApi className="gameapi">
                    <Sections sections={sectionWhitelabel} />
                    <ScrollUp />
                </StyledGameApi>
            </Box>
            <Footer />
        </Box>
    );
};

GameApi.propTypes = {
    sections: PropTypes.array,
};

export default GameApi;
